// 设备管理
export default {
    permission: '权限',
    details: '详情',
    deviceID: '设备编号',
    serialNumber: '编号',
    devicwarrantyPeriodeID: '保修期',
    totalFlightTime: '飞行总时长',
    numberFlights: '飞行次数',
    equipmentType: '设备类型',
    pleaseChoose: '请选择',
    drone: '无人机',
    RTK: 'RTK',
    activationTime: '激活时间',
    weatherStation: '气象站',
    editDevice: '编辑设备',
    addDevice: '添加设备',
    snCode: 'SN码',
    factoryTime: '出厂时间',
    deviceName: '设备名称',
    uploadImage: '上传图片',
    deviceDetails: '设备详情',
    permissionSettings: '权限设置',
    deviceNameNoreapt: '设备名称已经存在，不能重复',
    required: '必填',
    all: '全部',
    rtk: 'rtk',
    totalEquipment: '设备总计',
    deviceManagement: '设备管理',
    enterSnCode: '请输入SN码',
    isdelDevice: '设备删除后，设备绑定关系将被删除，是否删除设备？',
    delDevice: '删除设备',
    delSuccess: '删除成功',
    deviceStatus: '设备状态',
    networkStatus: '网络状态',
    entryTime: '录入时间',
    permissionStatus: '权限状态',
    versionNumber: '版本号',
    user: '使用人',
    operate: '操作',
    shared: '已共享',
    isShared: '被共享',
    notShared: '未共享',
    offline: '离线',
    online: '在线',
    test: '测试',
    pendingSale: '待销售',
    using: '使用中',
    inMaintenance: '维修中',
    disable: '停用',
    scrapped: '报废',
    department: '部门',
    addDepartment: '添加部门',
    nameQuery: '姓名查询',
    name: '姓名',
    mobilePhone: '手机',
    license: '执照',
    licenseType: '执照类型',
    isName: '名称',
    deptIsRepeat:'此部门已存在！请重新选择部门',
    selcetHasUserDept:'请选择有用户的部门',
    cloudTime:'上云时间',
    operationUser:'操作用户',
    authorizedTime:'授权时间',
    authorizationDeadline:'授权截止时间',
    cloudDevice:'上云设备',
    equipmentModel:'设备型号',
    syDeviceNum:'组织授权上云设备数量',

    deptIsRepeat: '此部门已存在！请重新选择部门',
    selcetHasUserDept: '请选择有用户的部门',
    admin: '管理员',
    tips_AHTH: '管理员拥有所有设备的最高权限',
}
